import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentLinesTableRowCtrl implements IController {

  fulfillment: any;
  isCollapse: boolean;
  isSelected: string;
  onOpen: Function;
  onDispatch: Function;

  private customers: any;
  private stepProgress: any;
  private totalItems: number;

  /* @ngInject */
  constructor() {}

  $onInit() {
    this.customers = [];
    this.stepProgress = {stepNumber: 0, numberOfSteps: 0};

    if (this.fulfillment) {
      this.totalItems = this._getTotalItems();
      this._getStepProgress();

      if(_.get(this.fulfillment, 'fulfillmentSteps.length')) {
        this.customers = this._mapCustomers();
      }
    }
  }

  $onChanges(changes) {
    if (changes.fulfillment && !changes.fulfillment.isFirstChange()) {
      this.$onInit();
    }
  }

  private _mapCustomers() {
    return _.chain(this.fulfillment.fulfillmentSteps)
    .map((step) => {
      return {
        name: _.get(step.destination, 'contact.name'),
        phone: _.get(step.destination, 'contact.phoneNo'),
        address: _.get(step.destination, 'location.address')
      }
    })
    .uniqBy('phone')
    .value();
  }

  private _getStepProgress() {
    var completedCount = 0;
    _.forEach(_.get(this.fulfillment, 'fulfillmentSteps'), (step) => {
      completedCount += step.status === 'Completed' ? 1 : 0;
    })
    this.stepProgress = {stepNumber: completedCount, numberOfSteps: _.get(this.fulfillment, 'fulfillmentSteps.length') || 0};
  }

  private _getTotalItems() {
    return _.reduce(_.get(this.fulfillment,'items'), (sum, item) => {
      return sum + item.count;
    }, 0);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLinesTableRow', {
    bindings: {
      fulfillment: '<',
      isCollapse: '<',
      isSelected: '<',
      onOpen: '&',
      onDispatch: '&'
    },
    template: require('./fulfillment-lines-table-row.html').default,
    controller: FulfillmentLinesTableRowCtrl
  });
